import SortArrows from '../../components/icons/sort-arrows.jsx';
import { setSorting, setCheckedItems } from '../../store/usersSlice';

export const pageTabsConfig = [
    { id: 'users', label: 'Użytkownicy' },
    { id: 'admins', label: 'Administratorzy' },
    { id: 'messageReports', label: 'Zgłoszenia wiadomości' },
    { id: 'reports', label: 'Zgłoszenia profili' },
    { id: 'blocked', label: 'Zablokowani' },
];

export const getHeaders = (
    sortBy,
    sortDirection,
    dispatch,
    sortArrowColorActive,
    sortArrowColorInactive,
    rowsData,
    checkedItems,
    pageTab
) => {
    const allIds = rowsData.map((row) => row.id);
    const allChecked = rowsData.length > 0 && checkedItems.length > 0 && allIds.every((id) => checkedItems.includes(id));

    const baseHeaders = [
        <label
            key="header-checkbox-label"
            className="checkbox-wrapper"
            onClick={(e) => e.stopPropagation()}
        >
            <input
                id="header-checkbox-all"
                name="header-checkbox-all"
                type="checkbox"
                checked={allChecked}
                onChange={(e) => {
                    if (e.target.checked) {
                        dispatch(setCheckedItems([...new Set([...checkedItems, ...allIds])]));
                    } else {
                        dispatch(setCheckedItems(checkedItems.filter((id) => !allIds.includes(id))));
                    }
                }}
            />
        </label>,
    ];

    if (pageTab === 'messageReports') {
        return [baseHeaders[0], <div key="report-id">ID grupy zgłoszeń</div>, <div key="sender">Zgłaszający</div>, <div key="bunch-id">Czat</div>, <div key="reports">Raporty</div>, <div key="messages">Wiadomości</div>, <div key="reason">Powód</div>, <div key="status">Status</div>, <div key="actions">Akcje</div>];
    }

    if (pageTab === 'reports') {
        return [
            baseHeaders[0],
            <div key="id-header" className="table-columns-headers">
                <div>ID</div>
                <SortArrows
                    upColor={sortBy === 'id' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
                    downColor={sortBy === 'id' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
                    className="menu-icon"
                    onClick={() => handleSort('id', sortBy, sortDirection, dispatch)}
                />
            </div>,
            <div key="nick-header" className="table-columns-headers">
                <div>Nick (imię nazwisko)</div>
                <SortArrows
                    upColor={sortBy === 'nickname' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
                    downColor={sortBy === 'nickname' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
                    className="menu-icon"
                    onClick={() => handleSort('nickname', sortBy, sortDirection, dispatch)}
                />
            </div>,
            <div key="gender-header">Płeć</div>,
            <div key="email-header">Adres e-mail</div>,
            <div key="phone-header">Numer telefonu</div>,
            <div key="report-date-header" className="table-columns-headers">
                <div>Data zgłoszenia</div>
                <SortArrows
                    upColor={sortBy === 'reportDate' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
                    downColor={sortBy === 'reportDate' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
                    className="menu-icon"
                    onClick={() => handleSort('reportDate', sortBy, sortDirection, dispatch)}
                />
            </div>,
            <div key="reporter-header" className="table-columns-headers">
                <div>Zgłaszający</div>
                <SortArrows
                    upColor={sortBy === 'reporterName' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
                    downColor={sortBy === 'reporterName' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
                    className="menu-icon"
                    onClick={() => handleSort('reporterName', sortBy, sortDirection, dispatch)}
                />
            </div>,
            <div key="report-reason-header" className="table-columns-headers">
                <div>Powód zgłoszenia</div>
                <SortArrows
                    upColor={sortBy === 'reportReason' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
                    downColor={sortBy === 'reportReason' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
                    className="menu-icon"
                    onClick={() => handleSort('reportReason', sortBy, sortDirection, dispatch)}
                />
            </div>,
            <div key="actions-header">Akcje</div>,
        ];
    }

    return [
        baseHeaders[0],
        <div key="id-header" className="table-columns-headers">
            <div>ID</div>
            <SortArrows
                upColor={sortBy === 'id' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
                downColor={sortBy === 'id' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
                className="menu-icon"
                onClick={() => handleSort('id', sortBy, sortDirection, dispatch)}
            />
        </div>,
        <div key="nick-header" className="table-columns-headers">
            <div>Nick (imię nazwisko)</div>
            <SortArrows
                upColor={sortBy === 'nickname' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
                downColor={sortBy === 'nickname' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
                className="menu-icon"
                onClick={() => handleSort('nickname', sortBy, sortDirection, dispatch)}
            />
        </div>,
        <div key="gender-header">Płeć</div>,
        <div key="email-header">Adres e-mail</div>,
        <div key="phone-header">Numer telefonu</div>,
        <div key="date-header" className="table-columns-headers">
            <div>Data rejestracji</div>
            <SortArrows
                upColor={sortBy === 'registrationDate' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
                downColor={sortBy === 'registrationDate' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
                className="menu-icon"
                onClick={() => handleSort('registrationDate', sortBy, sortDirection, dispatch)}
            />
        </div>,
        <div key="status-header" className="table-columns-headers">
            <div>Status</div>
            <SortArrows
                upColor={sortBy === 'status' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
                downColor={sortBy === 'status' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
                className="menu-icon"
                onClick={() => handleSort('status', sortBy, sortDirection, dispatch)}
            />
        </div>,
        <div key="packs-header">Utworzone paczki</div>,
        <div key="likes-header">Polubione wydarzenia</div>,
        <div key="actions-header">Akcje</div>,
    ];
};

const handleSort = (columnName, sortBy, sortDirection, dispatch) => {
    if (sortBy !== columnName) {
        dispatch(setSorting({ sortBy: columnName, sortDirection: 'ASC' }));
    } else {
        if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: columnName, sortDirection: 'DESC' }));
        } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
        }
    }
};

// Checkbox | ID | Nick | Gender | Email | Phone | Registration | Status | Packs | Likes | Actions
export const headerWidths = [
    '56px',
    '72px',
    '1.4fr',
    '0.6fr',
    '1.1fr',
    '0.8fr',
    '0.9fr',
    '0.8fr',
    '0.8fr',
    '0.9fr',
    '96px',
];

export const reportsHeaderWidths = [
    '56px',
    '72px',
    '1.2fr',
    '0.6fr',
    '1.2fr',
    '0.9fr',
    '0.9fr',
    '1.1fr',
    '1.1fr',
    '96px',
];

export const messageReportsHeaderWidths = ['56px', '1.5fr', '1.2fr', '1.2fr', '0.7fr', '0.9fr', '1.4fr', '1fr', '96px'];

export const deleteSelected = (selectedIds) => {
    console.log('Delete selected users:', selectedIds);
    if (selectedIds.length === 0) {
        alert('Nie wybrano żadnych użytkowników do usunięcia');
        return;
    }
    if (window.confirm(`Czy na pewno chcesz usunąć ${selectedIds.length} użytkowników?`)) {
        alert('Funkcja usuwania w trakcie implementacji');
    }
};
